<app-page-breadcrumb pageTitle="Configuración de WhatsApp"></app-page-breadcrumb>

<div class="mb-4 flex items-center justify-between">
  <p class="text-sm text-gray-500 dark:text-gray-400">
    Conectá la cuenta de WhatsApp Business del negocio y asigná números a los usuarios.
  </p>
  <button
    type="button"
    (click)="reload()"
    [disabled]="loading || saving"
    class="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
  >
    <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
    </svg>
    Recargar
  </button>
</div>

@if (errorMessage) {
  <div class="mb-4 flex items-start gap-3 rounded-lg bg-red-50 p-3 text-sm text-red-700 dark:bg-red-900/20 dark:text-red-300">
    <span class="flex-1">{{ errorMessage }}</span>
    <button type="button" (click)="errorMessage = null" class="text-red-500 hover:text-red-700">×</button>
  </div>
}

@if (successMessage) {
  <div class="mb-4 flex items-start gap-3 rounded-lg bg-emerald-50 p-3 text-sm text-emerald-700 dark:bg-emerald-900/20 dark:text-emerald-300">
    <span class="flex-1">{{ successMessage }}</span>
    <button type="button" (click)="successMessage = null" class="text-emerald-500 hover:text-emerald-700">×</button>
  </div>
}

@if (loading) {
  <div class="rounded-xl border border-gray-200 bg-white p-8 text-center text-sm text-gray-500 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400">
    Cargando…
  </div>
} @else if (!account) {
  <!-- Empty state: no conectado -->
  <div class="rounded-xl border border-gray-200 bg-white p-8 dark:border-gray-800 dark:bg-gray-900">
    <div class="mx-auto max-w-md text-center">
      <div class="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-100 dark:bg-emerald-900/40">
        <svg class="h-7 w-7 text-emerald-600 dark:text-emerald-400" fill="currentColor" viewBox="0 0 24 24">
          <path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.946C.16 5.335 5.495 0 12.05 0c3.181 0 6.167 1.24 8.413 3.488a11.82 11.82 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.51 5.26L3.51 19.05l1.144 1.143zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z"/>
        </svg>
      </div>
      <h2 class="mb-2 text-lg font-semibold text-gray-900 dark:text-white">
        Conectá WhatsApp Business
      </h2>
      <p class="mb-5 text-sm text-gray-500 dark:text-gray-400">
        Vinculá tu cuenta de WhatsApp Business (WABA) mediante Embedded Signup. Usaremos los números autorizados para enviar y recibir mensajes desde el CRM.
      </p>
      <button
        type="button"
        (click)="connect()"
        [disabled]="saving"
        class="inline-flex items-center gap-2 rounded-lg bg-emerald-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-emerald-700 disabled:opacity-60"
      >
        @if (saving) {
          <svg class="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
          </svg>
        }
        Conectar con Meta
      </button>
    </div>

    <!-- Conexión manual: sirve mientras Meta no aprueba la app como proveedor de tecnología -->
    <div class="mx-auto mt-8 max-w-xl border-t border-gray-200 pt-6 dark:border-gray-800">
      <button
        type="button"
        (click)="manualOpen = !manualOpen"
        class="flex w-full items-center justify-between text-left text-sm font-medium text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
      >
        <span>Conexión manual (pruebas)</span>
        <span class="text-xs">{{ manualOpen ? '▲' : '▼' }}</span>
      </button>

      @if (manualOpen) {
        <p class="mt-3 text-xs text-gray-500 dark:text-gray-400">
          Usala mientras la app de Meta no esté aprobada como proveedor de tecnología y el
          Embedded Signup siga bloqueado. Los datos salen del panel de Meta, en
          <span class="font-medium">WhatsApp → API Setup</span>. El token temporal dura 24 horas.
        </p>

        <div class="mt-4 space-y-3">
          <div>
            <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">
              WhatsApp Business Account ID <span class="text-red-500">*</span>
            </label>
            <input
              type="text"
              [(ngModel)]="manualForm.wabaId"
              name="wabaId"
              placeholder="123456789012345"
              class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
            />
          </div>

          <div>
            <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">
              Access token <span class="text-red-500">*</span>
            </label>
            <input
              type="password"
              [(ngModel)]="manualForm.accessToken"
              name="accessToken"
              placeholder="EAAxxx…"
              class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
            />
          </div>

          <div>
            <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">
              Phone number ID
            </label>
            <input
              type="text"
              [(ngModel)]="manualForm.phoneNumberId"
              name="phoneNumberId"
              placeholder="Opcional: si lo dejás vacío se consultan todos los números de la WABA"
              class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
            />
          </div>

          <div>
            <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">
              Número visible
            </label>
            <input
              type="text"
              [(ngModel)]="manualForm.displayPhoneNumber"
              name="displayPhoneNumber"
              placeholder="Opcional: +51 999 888 777"
              class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
            />
          </div>

          <button
            type="button"
            (click)="connectManually()"
            [disabled]="saving"
            class="inline-flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-60 dark:border-gray-700 dark:text-gray-200 dark:hover:bg-gray-800"
          >
            Conectar manualmente
          </button>
        </div>
      }
    </div>
  </div>
} @else {
  <!-- Conectado: tarjeta cuenta -->
  <div class="mb-4 rounded-xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-gray-900">
    <div class="flex flex-wrap items-start justify-between gap-3">
      <div>
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white">
          WABA · {{ account.wabaId }}
        </h2>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Estado:
          <span class="ml-1 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-700 dark:bg-gray-800 dark:text-gray-300">
            {{ accountStatusLabel(account.status) }}
          </span>
          @if (account.tokenExpiresAt) {
            <span class="ml-2 text-xs">Token vence: {{ account.tokenExpiresAt | date:'medium' }}</span>
          }
        </p>
      </div>
      <div class="flex items-center gap-2">
        <button
          type="button"
          (click)="connect()"
          [disabled]="saving"
          class="rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm font-medium text-emerald-700 hover:bg-emerald-100 disabled:opacity-60 dark:border-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300"
        >
          Reconectar
        </button>
        <button
          type="button"
          (click)="disconnect()"
          [disabled]="saving"
          class="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm font-medium text-red-700 hover:bg-red-100 disabled:opacity-60 dark:border-red-800 dark:bg-red-900/30 dark:text-red-300"
        >
          Desconectar
        </button>
      </div>
    </div>

    @if (statusBanner().variant === 'warning') {
      <div class="mt-4 rounded-lg bg-amber-50 p-3 text-sm text-amber-800 dark:bg-amber-900/20 dark:text-amber-300">
        {{ statusBanner().text }}
      </div>
    } @else if (statusBanner().variant === 'danger') {
      <div class="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-700 dark:bg-red-900/20 dark:text-red-300">
        {{ statusBanner().text }}
      </div>
    }
  </div>

  <!-- Tabla de phones -->
  <div class="rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900">
    <div class="border-b border-gray-200 p-4 dark:border-gray-800">
      <h3 class="text-base font-semibold text-gray-900 dark:text-white">Números asociados</h3>
    </div>
    @if (!account.phones || account.phones.length === 0) {
      <div class="p-6 text-center text-sm text-gray-500 dark:text-gray-400">
        La WABA no tiene números registrados. Configurá uno en Meta Business Manager.
      </div>
    } @else {
      <div class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead class="bg-gray-50 text-left text-xs uppercase tracking-wide text-gray-500 dark:bg-gray-800/50 dark:text-gray-400">
            <tr>
              <th class="px-4 py-3 font-medium">Número</th>
              <th class="px-4 py-3 font-medium">Nombre verificado</th>
              <th class="px-4 py-3 font-medium">Calidad</th>
              <th class="px-4 py-3 font-medium">Registrado</th>
              <th class="px-4 py-3 text-right font-medium">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
            @for (p of account.phones; track p.id) {
              <tr>
                <td class="px-4 py-3 font-medium text-gray-900 dark:text-white">
                  {{ p.displayPhoneNumber }}
                  <span class="block text-xs text-gray-500 dark:text-gray-400">
                    id: {{ p.phoneNumberId }}
                  </span>
                </td>
                <td class="px-4 py-3 text-gray-700 dark:text-gray-300">
                  {{ p.verifiedName || '—' }}
                </td>
                <td class="px-4 py-3">
                  <span class="rounded-full px-2 py-0.5 text-xs font-medium" [ngClass]="qualityClass(p.qualityRating)">
                    {{ qualityRatingLabel(p.qualityRating) }}
                  </span>
                </td>
                <td class="px-4 py-3">
                  @if (p.registered) {
                    <span class="text-emerald-600 dark:text-emerald-400">Sí</span>
                  } @else {
                    <span class="text-red-600 dark:text-red-400">No</span>
                  }
                </td>
                <td class="px-4 py-3 text-right">
                  <button
                    type="button"
                    (click)="openAssign(p)"
                    class="rounded-lg bg-teal-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-teal-700"
                  >
                    Asignar usuarios
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
}

@if (!loading) {
  <!-- Alta automática de contactos. Va fuera del bloque de la cuenta a propósito: el
       endpoint responde igual sin cuenta conectada, y esconder el ajuste dejaba al
       cliente sin saber que existe. -->
  <div class="mt-4 rounded-xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-gray-900">
    <div class="flex flex-wrap items-start justify-between gap-4">
      <div class="min-w-0 flex-1">
        <h3 class="text-base font-semibold text-gray-900 dark:text-white">
          Crear contactos automáticamente
        </h3>
        <p class="mt-1 max-w-2xl text-sm text-gray-500 dark:text-gray-400">
          Cuando está activado, cada número desconocido que escriba por WhatsApp crea al
          instante su ficha en Contactos. Con el número de producción eso son decenas de
          fichas nuevas al día, y la cartera comercial queda enterrada entre ellas.
        </p>
        <p class="mt-2 max-w-2xl text-sm text-gray-500 dark:text-gray-400">
          <span class="font-medium text-gray-700 dark:text-gray-300">Apagado</span>, los
          mensajes siguen llegando igual a la bandeja: lo único que no pasa es que se cree
          la ficha. Cuando una conversación valga la pena, se crea a mano desde la propia
          bandeja con el botón «Crear contacto».
        </p>

        @if (!puedeEditarPermiso) {
          <p class="mt-3 text-xs font-medium text-amber-600 dark:text-amber-400">
            Sólo un Admin o Super Admin puede cambiar este ajuste. Podés verlo, pero no
            modificarlo.
          </p>
        } @else if (settings && !settings.connected) {
          <p class="mt-3 text-xs font-medium text-amber-600 dark:text-amber-400">
            Conectá una cuenta de WhatsApp para poder cambiar este ajuste.
          </p>
        } @else if (!settings && !settingsLoading) {
          <p class="mt-3 text-xs font-medium text-amber-600 dark:text-amber-400">
            No se pudieron leer los ajustes de WhatsApp. Probá con «Recargar».
          </p>
        }
      </div>

      <div class="flex shrink-0 items-center gap-3">
        @if (settingsSaving) {
          <span class="text-xs text-gray-500 dark:text-gray-400">Guardando…</span>
        }
        <label class="relative inline-flex shrink-0 cursor-pointer items-center">
          <input
            type="checkbox"
            class="peer sr-only"
            [(ngModel)]="autoCreateContacts"
            (ngModelChange)="onAutoCreateContactsChange($event)"
            [disabled]="!canEditSettings"
            name="autoCreateContacts"
          />
          <div class="h-6 w-11 rounded-full bg-gray-200 transition-colors peer-checked:bg-emerald-600 peer-disabled:opacity-50 dark:bg-gray-700"></div>
          <div class="absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform peer-checked:translate-x-5 peer-disabled:opacity-50"></div>
        </label>
      </div>
    </div>
  </div>
}

@if (!loading) {
  <!-- Mantenimiento. El enlace se ofrece siempre, tambien sin cuenta conectada: las fichas
       que dejo el alta automatica siguen ahi aunque se haya desconectado WhatsApp. La
       herramienta vive en su propia pantalla porque es destructiva y necesita espacio para
       enseñar el desglose completo antes de que nadie confirme nada. -->
  <div class="mt-4 rounded-xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-gray-900">
    <div class="flex flex-wrap items-start justify-between gap-4">
      <div class="min-w-0 flex-1">
        <h3 class="text-base font-semibold text-gray-900 dark:text-white">
          Limpiar los contactos que ya se crearon
        </h3>
        <p class="mt-1 max-w-2xl text-sm text-gray-500 dark:text-gray-400">
          Apagar el interruptor evita fichas nuevas, pero no toca las que ya existen. En la
          pantalla de limpieza verás cuántas hay y qué se llevaría por delante borrarlas,
          antes de decidir. Las conversaciones y los mensajes de WhatsApp no se borran.
        </p>
      </div>
      <a
        routerLink="/whatsapp/limpieza-contactos"
        class="shrink-0 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
      >
        Ver qué se puede limpiar
      </a>
    </div>
  </div>
}

<app-whatsapp-assignment-modal
  [isOpen]="assignmentModalOpen"
  [phone]="assignmentTarget"
  (close)="closeAssign()"
></app-whatsapp-assignment-modal>
